let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2m2FL")).then(() => parcelRequire('51BUM'));